import { Document, Page, View, Text, Image, Link } from '@react-pdf/renderer';
import {
  ActionItems,
  PageHeader,
  PageHeaderLogo,
  styles,
  Notes,
  PageFooter,
} from '../constants';
import { keys } from '../../translator/translation_keys';
import { useTranslation } from 'react-i18next';
import { imageExtensions } from '../../files';

export const ObservationDocument = ({
  observation,
  company,
  props = [],
  notes = [],
}) => {
  const { t } = useTranslation();

  const questions = JSON.parse(observation?.items);

  const secondsight = observation.riskAnalysis;

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <PageHeaderLogo company={company} />
        <PageHeader
          company={company}
          data={observation}
          title={observation?.title || `Untitled`}
          workspace={observation.workspace}
          type="Observation"
        />
        <View>
          <Text style={styles.titleHeader}>
            {observation?.type} -{' '}
            {!observation?.negative
              ? t(keys.observations.POSITIVE)
              : t(keys.observations.ACTION_REQUIRED)}
          </Text>
        </View>
        <View>
          <Text style={styles.categoryHeader}>{t(keys.common.DETAILS)}</Text>
          <View style={styles.row}>
            <Text style={styles.text}>
              {t(keys.observations.DATE_AND_TIME)}
            </Text>
            <Text style={styles.text}>{observation.dateTime}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.text}>{t(keys.common.LOCATION)}</Text>
            <Text style={styles.text}>{observation.location}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.text}>{t(keys.common.DESCRIPTION)}</Text>
            <Text style={styles.text}>{observation.description}</Text>
          </View>
          {questions?.length > 0 &&
            questions.map((question) => (
              <View style={styles.row}>
                <Text style={styles.text}>{question.title}</Text>
                <Text style={styles.text}>{question.value}</Text>
              </View>
            ))}
        </View>
        {props.includes('secondsight') && (
          <View>
            <Text style={styles.categoryHeader}>
              {t(keys.assessments.SECOND_SIGHT_ANALYSIS)}
            </Text>
            {secondsight?.potential_hazards?.length && (
              <View>
                <Text style={styles.actionItemTitle}>
                  {t(keys.observations.POTENTIAL_HAZARDS)}
                </Text>
                {secondsight?.potential_hazards?.map((p) => (
                  <View style={styles.row}>
                    <Text style={styles.textFullWidth}>{p}</Text>
                  </View>
                ))}
              </View>
            )}
            {secondsight?.mitigations?.length && (
              <View>
                <Text style={styles.actionItemTitle}>
                  {t(keys.observations.POTENTIAL_MITIGATIONS)}
                </Text>
                {secondsight?.mitigations?.map((m) => (
                  <View style={styles.row}>
                    <Text style={styles.textFullWidth}>{m}</Text>
                  </View>
                ))}
              </View>
            )}
          </View>
        )}
        {props.includes('actions') && (
          <ActionItems actionItems={observation?.actionItems} />
        )}
        {props?.includes('notes') && (
          <View style={styles.categoryContainer}>
            <Notes notes={notes} style={styles.categoryContainer} />
          </View>
        )}
        {props.includes('files') && (
          <View style={styles.categoryContainer}>
            <Text style={styles.categoryHeader}>
              {t(keys.common.REFERENCE_FILES)}
            </Text>
            <View style={styles.templateImageContainer}>
              {observation?.images?.map((file, index) => {
                const { imageUrl, name, id } = file || {};
                const src = imageUrl;
                const ext = src?.split('.')?.pop();
                return imageExtensions.includes(ext) ? (
                  <Image
                    style={styles.templateImage}
                    src={src}
                    key={`${id}-${index}`}
                  />
                ) : (
                  <View key={id}>
                    <Link style={styles.linkLeft} src={src}>
                      {name}
                    </Link>
                  </View>
                );
              })}
            </View>
          </View>
        )}
        <PageFooter />
      </Page>
    </Document>
  );
};
